import React from 'react';
import { formatPrice } from '../../utils/formatterUtils';

function Row({ label, color, data }) {
  const previsto = data?.previsto || 0;
  const reale = data?.reale || 0;
  const percent = previsto > 0 ? (reale / previsto) * 100 : 0;
  const delta = data?.delta || previsto - reale;
  const deltaLabel = `${delta > 0 ? '+' : delta < 0 ? '−' : ''} ${formatPrice(Math.abs(delta))}`;
  const deltaClass = delta >= 0 ? 'delta--ok--previstoVsReale' : 'delta--bad--previstoVsReale';

  return (
    <div className="cc-row--previstoVsReale">
      <div>
        <div className="cc-title--previstoVsReale"><span className={`dot ${color}`}></span>{label}</div>
        <div className="cc-track--previstoVsReale">
          <span className="cc-plan--previstoVsReale" style={{ width: '100%' }}></span>
          <span className="cc-actual--previstoVsReale" style={{ width: `${Math.min(percent, 100)}%` }}></span>
        </div>
      </div>
      <div className="cc-right--previstoVsReale">
        <div className="cc-kv--previstoVsReale"><span>Previsto</span><span className="v--previstoVsReale">{formatPrice(previsto)}</span></div>
        <div className="cc-kv--previstoVsReale"><span>Reale</span><span className="v--previstoVsReale">{formatPrice(reale)}</span></div>
        <span className={deltaClass}> U/P: {deltaLabel}</span>
      </div>
    </div>
  );
}

export default function CostiPrevistiRealiCard({ data }) {
  if (!data?.costCompare) return null;
  const {
    terreno,
    costruzione,
    progettazione,
    costiVari,
    commercializzazione,
    costiBanca,
  } = data.costCompare;

  return (
    <article className="card-dash card--previstoVsReale">
      <h3>Confronto Costi Previsti Vs. Costi Reali</h3>
      <div className="cc-head--previstoVsReale">
        <div className="leg--previstoVsReale"><span className="swatch--previstoVsReale plan--previstoVsReale"></span><span>Previsti</span></div>
        <div className="leg--previstoVsReale"><span className="swatch--previstoVsReale actual--previstoVsReale"></span><span>Reali</span></div>
      </div>
      <div className="cost-compare--previstoVsReale">
        <Row label="Terreno" color="red" data={terreno} />
        <Row label="Costruzione" color="amber" data={costruzione} />
        <Row label="Progettazione" color="amber" data={progettazione} />
        <Row label="Costi Vari" color="green" data={costiVari} />
        <Row label="Commercializzazione" color="green" data={commercializzazione} />
        <Row label="Costi Banca" color="green" data={costiBanca} />
      </div>
    </article>
  );
}
